import { Injectable } from '@angular/core';
import {
    CanActivate,
    CanLoad,
    Router,
} from '@angular/router';
import { EnterpriseService } from '@core/enterprise/enterprise.service';
import { Observable } from 'rxjs';
import {
    map,
    tap,
} from 'rxjs/operators';

@Injectable()
export class NotAllowMultiEnterprisesAccessGuardService implements CanLoad, CanActivate {
    constructor(
        private enterpriseService: EnterpriseService,
        private router: Router,
    ) { }

    public canLoad(): Observable<boolean> {
        return this.enterpriseService
            .getEnterpriseInfo().pipe(
                tap(({ isLocalVersion }: any) => {
                    if (!isLocalVersion) {
                        this.router.navigate(['page-forbidden']);
                    }
                }),
                map(({ isLocalVersion }: any) => isLocalVersion));
    }

    public canActivate(): Observable<boolean> {
        return this.canLoad();
    }
}
